import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.heading',
		defaultMessage: 'Jira Service Management',
		description: 'Navigation group heading for Jira Service Management settings items',
	},
	configurationItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.configuration-item',
		defaultMessage: 'Configuration',
		description: 'Navigation item which links to Jira Service Management configuration page',
	},
	complianceSettingsItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.compliance-settings-item',
		defaultMessage: 'Compliance settings',
		description: 'Navigation item which links to Jira Service Management compliance page',
	},
	emailRequestsItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.email-requests-item',
		defaultMessage: 'Email requests',
		description:
			'Navigation item which links to a Jira Service Management email requests settings page',
	},
	customerAccessItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.customer-access-item',
		defaultMessage: 'Customer access',
		description:
			'Navigation item which links to a Jira Service Management Customer access settings page',
	},
	incidentManagementItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.incident-management-item',
		defaultMessage: 'Incident management',
		description: 'Navigation item which links to a Jira Service incident management',
	},
	knowledgeBasePermissionsItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.knowledge-base-permissions-item',
		defaultMessage: 'Knowledge base permissions',
		description: 'Navigation item which links to a Jira Service Management Knowledge Base Settings',
	},
	authenticationItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.authentication-item',
		defaultMessage: 'Authentication',
		description:
			'Navigation item which links to a Jira Service Management Authentication settings page',
	},
	organizationsItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.organizations-item',
		defaultMessage: 'Organizations',
		description: 'Navigation item which links to the Organizations List page',
	},
	featureUsageItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.service-management-section.feature-usage-item',
		defaultMessage: 'Feature usage',
		description:
			'Navigation item which links to a Jira Service Management Feature Usage settings page',
	},
});
